


















import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import BindAttrs from '@/utils/binds-attrs';

/**
 * General Component for Fields of type COSL (COMPANY_SELECTION_V2)
 */
@Component({
    mixins: [BindAttrs]
})
export default class AmetrasCOSLTemplate extends Vue {
    @Prop() marginDefinition!: string;
    @Prop() paddingDefinition!: string;
    @Prop() value!: boolean;
    @Prop() label!: string;
    @Prop({
        type: Array as () => string[]
    }) selectValues!: DisguiseDto.SelectDto[];
    innerValue: boolean = false;

    created() {
        this.innerValue = this.value;
    }

    @Watch('value') valueChanged(newValue: boolean) {
        this.innerValue = newValue;
    }

    @Watch('innerValue') innerValueChanged(newValue: boolean) {
        this.$emit('input', newValue);
    }

}

